export enum CardMode {
    ReadOnly = 1,
    Edit,
    Process,
    InvalidInput,
    ServerError,
}
